/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";

// IMPORTING COMPONENTS
import LeftPanel from "../../../components/LeftPanel";
import Header from "../../../components/Header";
import CustomDropDown from "../../../components/CustomDropDown";

// IMPORTING ICONS
import spinner from "../../../images/reports-spinner.gif";
import { KeyboardArrowUp as UpIcon, KeyboardArrowDown as DownIcon } from "@mui/icons-material";

// IMPORTING REACT-DATEPICKER
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const server = 'https://api.myfooddo.com';
// const server = 'http://localhost:5000';

const getGMTDate = param => {
  const offset = -(new Date(param).getTimezoneOffset()) * 60000
  const date = new Date(param).setHours(0, 0, 0, 0)
  const offsetDate = date + offset
  return offsetDate
}

// Hardcoded Values
const columnsArray = [
  "S.No.",
  "Amount",
  "Local Order Id",
  "Settlement",
  "Payment Time",
  "Settlement Time",
  "Customer"
]

const dropdownOptions = {
  date_type: [
    { label: 'Payment Time', value: 1 },
    { label: 'Settlement Time', value: 2 }
  ],
  settlement_status: [
    { label: 'All', value: -1 },
    { label: 'Pending', value: '0' },
    { label: 'Clear', value: '1' },
  ]
}

const dropdownStyle = {
  container: { position: 'unset' },
  label: { padding: '4px 10px' },
  select: { borderRadius: '0', width: '9.5rem' }
}

// Components
const defaultFilter = {
  date_range: {
    from: getGMTDate(Date.now()),
    to: getGMTDate(Date.now())
  },
  dateFor: dropdownOptions.date_type[0].value,
}

const UPIPayments = () => {

  const [isItemAvilableOpen, setIsItemAvilableOpen] = useState(false);
  const [tableColumns, setTableColumns] = useState(null);
  const [reportsRenderCollection, setReportsRenderCollection] = useState(null);
  const [loading, setLoading] = useState(false);

  const searchHandler = (filters = defaultFilter) => {
    setLoading(true);
    fetch(server + '/upi_payments/reports', {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      },
      body: JSON.stringify({
        filters,
        outlet_uuid: localStorage.getItem('outlet_uuid')
      }),
    })
      .then(res => res.json())
      .then(data => {
        setTableColumns(columnsArray);
        setReportsRenderCollection(data.records?.map(({ TxnCompletionDate: date, ...doc }, i) => ({
          "S.No.": i + 1,
          "Amount": doc.amt,
          "Local Order Id": doc.local_order_id || doc.payment_mode_name,
          "Settlement": +doc.settlement_status === 1 ? 'Clear' : 'Pending',
          "Payment Time": `${date.slice(6, 8)}/${date.slice(4, 6)}/${date.slice(0, 4)}, ${date.slice(8, 10)}:${date.slice(10, 12)}:${date.slice(12, 14)}`,
          "Settlement Time": +doc.settlement_status === 1 ? new Date(+doc.settlement_date).toLocaleString() : '-',
          "Customer": `${doc?.customer_mobile || ''}-${doc?.customer_name || ''}`
        })));
        setLoading(false);
      }).catch(error => console.warn(error.message))
  }

  useEffect(searchHandler, [])

  return (
    <>
      <LeftPanel
        setIsItemAvilableOpen={setIsItemAvilableOpen}
        isItemAvilableOpen={isItemAvilableOpen}
      />
      <Header />
      <div className="orders-report-container">
        <div id="heading"><h2>UPI Payment</h2></div>
        <OptionsHeader
          reportsRenderCollection={reportsRenderCollection}
          searchHandler={searchHandler}
        />
        <Table
          tableColumns={tableColumns}
          reportsRenderCollection={reportsRenderCollection}
          setReportsRenderCollection={setReportsRenderCollection}
          loading={loading}
          searchHandler={searchHandler}
        />
      </div>
    </>
  );
}

const OptionsHeader = ({ reportsRenderCollection, searchHandler }) => {

  const [datePickerState, setDatePickerState] = useState(defaultFilter.date_range)
  const [dateFor, setDateFor] = useState({ selected: defaultFilter.dateFor, visible: false, options: dropdownOptions?.date_type })
  const [settlementStatus, setSettlementStatus] = useState({ selected: -1, visible: false, options: dropdownOptions?.settlement_status })
  const search = () => {
    setDateFor(curr => ({ ...curr, visible: false }))
    searchHandler({
      settlement_status: +settlementStatus.selected >= 0 ? settlementStatus.selected : null,
      date_range: datePickerState?.from && datePickerState?.to ? datePickerState : null,
      dateFor: dateFor.selected || null,
    })
  }

  return (
    <div className="inputs-container" style={{ background: 'white', padding: '10px 5px', alignItems: 'flex-end', gap: '10px' }}>
      <div className="selection-field date-field from" style={{ margin: '0' }}>
        <label htmlFor="date-from">From date</label>
        <DatePicker
          id="date-from"
          className="date-picker small"
          dateFormat={'dd/MM/yy'}
          selected={datePickerState?.from}
          maxDate={Date.now()}
          onChange={date => {
            setDatePickerState({ from: getGMTDate(date), to: getGMTDate(date) })
            if (!dateFor?.selected) setDateFor(curr => ({
              ...curr, visible: true, selected: curr?.options?.[0]?.value
            }))
            document.getElementById('date-to').click();
            document.getElementById('date-to').focus();
          }}
          placeholderText="Enter Date From"
          wrapperClassName=""
          shouldCloseOnSelect={true}
        />
      </div>
      <div className="selection-field date-field to" style={{ margin: '0' }}>
        <label htmlFor="date-to">To date</label>
        <DatePicker
          id="date-to"
          className="date-picker small"
          dateFormat={'dd/MM/yy'}
          minDate={datePickerState.from}
          selected={datePickerState.to}
          maxDate={Date.now()}
          onChange={date => {
            setDatePickerState(curr => ({ ...curr, from: curr.from || getGMTDate(date), to: getGMTDate(date) }))
            if (!dateFor?.selected) setDateFor(curr => ({
              ...curr, visible: true, selected: curr?.options?.[0]?.value
            }))
            document.querySelector('.custom-select-container>button').focus()
          }}
          wrapperClassName=""
          placeholderText="Enter Date To"
          shouldCloseOnSelect={true}
        />
      </div>
      <CustomDropDown
        label={'Date For'}
        state={dateFor}
        setState={setDateFor}
        onSelect={selected => setDateFor(curr => ({ ...curr, visible: false, selected }))}
        styles={dropdownStyle}
      />
      <CustomDropDown
        label={'Settlement Status'}
        state={settlementStatus}
        setState={setSettlementStatus}
        onSelect={selected => setSettlementStatus(curr => ({ ...curr, visible: false, selected }))}
        styles={dropdownStyle}
      />
      <button id="filters-search-btn" style={{ margin: '0', fontSize: '.9rem', padding: '0 1.2rem' }} onClick={search}>Search</button>
      <div id="rightSided">
        {/* <button className="report-transparent-btn" onClick={search}>Failed Payments</button> */}
        <div className="report-stats container">
          <span>Total Records : {reportsRenderCollection?.length}</span>
          <span style={{ margin: '0' }}>Total Amount : {reportsRenderCollection?.reduce((sum, i) => sum + +i["Amount"], 0) || 0}</span>
        </div>
      </div>
    </div>
  )
}

const Table = ({
  tableColumns,
  reportsRenderCollection,
  setReportsRenderCollection,
  loading
}) => {

  const [tempOrders, setTempOrders] = useState(null);

  useEffect(() => {
    if (tempOrders) {
      setReportsRenderCollection(tempOrders);
    }
    return setTempOrders(null);
  }, [tempOrders]);// eslint-disable-line react-hooks/exhaustive-deps

  const sortFunctions = {

    "Local Order Id": function (op) {
      const outlets = reportsRenderCollection;
      if (op === "asc")
        outlets.sort((a, b) => {
          if (!a["Local Order Id"] && !b["Local Order Id"]) return 0;
          else return a["Local Order Id"].localeCompare(b["Local Order Id"]);
        });
      else if (op === "desc")
        outlets.sort((a, b) => {
          if (!a["Local Order Id"] && !b["Local Order Id"]) return 0;
          else return b["Local Order Id"].localeCompare(a["Local Order Id"]);
        });
      setTempOrders(outlets);
    },

    "Customer": function (op) {
      const outlets = reportsRenderCollection;
      if (op === "asc")
        outlets.sort((a, b) => {
          if (!a["Customer"] && !b["Customer"]) return 0;
          else return a["Customer"].localeCompare(b["Customer"]);
        });
      else if (op === "desc")
        outlets.sort((a, b) => {
          if (!a["Customer"] && !b["Customer"]) return 0;
          else return b["Customer"].localeCompare(a["Customer"]);
        });
      setTempOrders(outlets);
    },

    "Settlement": function (op) {
      const outlets = reportsRenderCollection;
      if (op === "asc")
        outlets.sort((a, b) => {
          if (!a["Settlement"] && !b["Settlement"]) return 0;
          else return a["Settlement"].localeCompare(b["Settlement"]);
        });
      else if (op === "desc")
        outlets.sort((a, b) => {
          if (!a["Settlement"] && !b["Settlement"]) return 0;
          else return b["Settlement"].localeCompare(a["Settlement"]);
        });
      setTempOrders(outlets);
    },

    "Payment Time": function (op) {
      const outlets = reportsRenderCollection;
      if (op === "asc") {
        outlets.sort((a, b) => +new Date(a["Payment Time"]).getTime() - new Date(b["Payment Time"]).getTime());
      } else if (op === "desc") {
        outlets.sort((a, b) => +new Date(b["Payment Time"]).getTime() - +new Date(a["Payment Time"]).getTime());
      }
      setTempOrders(outlets);
    },

    "Settlement Time": function (op) {
      const outlets = reportsRenderCollection;
      if (op === "asc") {
        outlets.sort((a, b) => +new Date(a["Settlement Time"]).getTime() - new Date(b["Settlement Time"]).getTime());
      } else if (op === "desc") {
        outlets.sort((a, b) => +new Date(b["Settlement Time"]).getTime() - +new Date(a["Settlement Time"]).getTime());
      }
      setTempOrders(outlets);
    },

    "S.No.": function (op) {
      const outlets = reportsRenderCollection;

      if (op === "asc") {
        outlets.sort((a, b) => {
          if (!a["S.No."] && !b["S.No."]) return 0;
          else return (+a["S.No."] - +b["S.No."]);
        });
      } else if (op === "desc") {
        outlets.sort((a, b) => {
          if (!a["S.No."] && !b["S.No."]) return 0;
          else return (+b["S.No."] - +a["S.No."]);
        });
      }
      setTempOrders(outlets);
    },

    "Amount": function (op) {
      const outlets = reportsRenderCollection;

      if (op === "asc") {
        outlets.sort((a, b) => {
          if (!a["Amount"] && !b["Amount"]) return 0;
          else return (+a["Amount"] - +b["Amount"]);
        });
      } else if (op === "desc") {
        outlets.sort((a, b) => {
          if (!a["Amount"] && !b["Amount"]) return 0;
          else return (+b["Amount"] - +a["Amount"]);
        });
      }
      setTempOrders(outlets);
    },
  };

  return (
    <div id="table-container">
      <div className="tabular-content report-orders-table">
        {loading && (<div id="reports-loading-spinner"><img src={spinner} alt="loading reports" /></div>)}
        {reportsRenderCollection && reportsRenderCollection.length > 0 ? (
          <>
            <table>
              <thead>
                <tr>
                  {reportsRenderCollection?.[0] && tableColumns?.map(column => (
                    <th key={Math.random()} style={{ overflow: 'unset' }}>
                      <div className="t-head-element">
                        <span>{column}</span>
                        {column && <div className="sort-buttons-container">
                          <button onClick={() => sortFunctions[column]("asc")} >
                            <UpIcon className="sort-up sort-button" />
                          </button>
                          <button onClick={() => sortFunctions[column]("desc")} >
                            <DownIcon className="sort-down sort-button" />
                          </button>
                        </div>}
                      </div>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {reportsRenderCollection.map((outlet, i) => (
                  <tr className="report-fields" key={i}>
                    {tableColumns?.map(label =>
                      <td key={Math.random()} className={`${label.toLowerCase().replaceAll(" ", "_")}`}>
                        {outlet[label] || "-"}
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>

            {/* {pages?.[0] && <div className="pagination orders-report">
              {pages.map(p => <div
                className={+currentPage === +p ? "active" : ""}
                onClick={() => pageLoad(p)}>{p}
              </div>)}
            </div>} */}
          </>
        ) : (<div id="no_reports">No Data</div>)}
      </div>
    </div>
  );
}

export default UPIPayments;